import { configureStore } from '@reduxjs/toolkit'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import Loader from '@/components/Loader/Loader'

import { rootReducer } from '@/store/rootReducer'

import App from './App'
import reportWebVitals from './reportWebVitals'


const store = configureStore({
  reducer: rootReducer,
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter basename="/urban">
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </BrowserRouter>
)

reportWebVitals()
